import { createAction, props } from '@ngrx/store';
import { Faqs } from './faqs.model';

// fetch all
export const fetchRecords = createAction(
    '[Data] fetch records faq'
);
export const fetchRecordsSuccess = createAction(
    '[Data] fetch records faq success', 
    props<{ listData: Faqs[], total: number }>()
);
export const fetchRecordsFail = createAction(
    '[Data] fetch records faq failure', 
    props<{ error: string }>()
);

// fetch one 
export const fetchSingleRecord = createAction(
    '[Data] fetch single record faq',
    props<{id: string}>()
);
export const fetchSingleRecordSuccess = createAction(
    '[Data] fetch single record faq success', 
    props<{ singleData: Faqs }>()
);
export const fetchSingleRecordFail = createAction(
    '[Data] fetch single record faq failure', 
    props<{ error: string }>()
);


// Add Data
export const addRecord = createAction(
    '[Data] Add record faq',
    props<{ newData: any }>()
);
export const addRecordSuccess = createAction(
    '[Data] Add record faq success'
);
export const addRecordFailure = createAction(
    '[Data] Add record faq failure',
    props<{ error: string }>()
);

// Update Data
export const updateRecord = createAction(
    '[Data] Update record faq',
    props<{ id: string; updatedData: any }>()
);
export const updateRecordSuccess = createAction(
    '[Data] Update record faq success'
);
export const updateRecordFailure = createAction(
    '[Data] Update record faq failure',
    props<{ error: string }>()
);

// Delete Data
export const deleteRecord = createAction(
    '[Data] Delete record faq',
    props<{ id: string }>()
);
export const deleteRecordSuccess = createAction(
    '[Data] Delete record faq success'
);
export const deleteRecordFailure = createAction(
    '[Data] Delete record faq failure',
    props<{ error: string }>()
);

//Reset State
export const resetState = createAction(
    '[Data] reset state faq',
);